/**
 * 浅色主题内联样式：绕过 wp-admin 全局 CSS
 * 入参为 useIsLightUi() 的布尔值，避免仅依赖 resolved 字段遗漏「显式浅色」
 */

import type { CSSProperties } from 'react';

export function modalOverlayInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return { backgroundColor: 'rgba(15, 23, 42, 0.35)' };
}

export function mainCardInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return {
    backgroundColor: '#f8fafc',
    border: '1px solid rgba(15, 23, 42, 0.08)',
    boxShadow: '0 20px 50px rgba(15, 23, 42, 0.12)',
  };
}

export function headerInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return {
    backgroundColor: '#ffffff',
    color: '#1e293b',
    borderBottom: '1px solid #e2e8f0',
  };
}

export function serverBarInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return {
    backgroundColor: '#f1f5f9',
    borderBottom: '1px solid #e2e8f0',
  };
}

export function messagesInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return { backgroundColor: '#f8fafc' };
}

export function inputAreaInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return {
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e2e8f0',
  };
}

export function textareaInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return {
    backgroundColor: '#f8fafc',
    color: '#0f172a',
    borderColor: '#cbd5e1',
    borderWidth: '1px',
    borderStyle: 'solid',
  };
}

/** Composer 卡片内的 textarea：背景由卡片承担，避免与底部工具栏叠层 */
export function composerTextareaInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return {
    backgroundColor: 'transparent',
    color: '#0f172a',
    border: 'none',
  };
}

export function themeSegInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return { borderColor: '#cbd5e1' };
}

export function serverNameInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return { color: '#4f46e5' };
}

export function serverIpInline(isLightUi: boolean): CSSProperties | undefined {
  if (!isLightUi) return undefined;
  return { color: '#64748b' };
}
